import { demoSeedMatters, demoSeedMessages } from './demoSeedMatters.js';

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

/** Gateway HTML must not be shown in the page. Cloudflare substitutes it for HTTP 502. */
export function readableApiError(message, status) {
  const raw = String(message || '').replace(/\s+/g, ' ').trim();
  const html = /<!doctype|<html[\s>]|<head[\s>]/i.test(raw);
  if (raw && !html && raw.length <= 240) return raw;
  if (status === 502 || status === 504 || html) {
    return 'DemandJet could not reach the server. Try again in a moment.';
  }
  return status ? `Request failed (${status})` : 'Something went wrong. Try again.';
}

function getToken() {
  try {
    const raw = localStorage.getItem('demandjet.session');
    if (!raw) return null;
    return JSON.parse(raw).token;
  } catch {
    return null;
  }
}

async function request(path, options = {}) {
  const headers = {
    ...DEFAULT_HEADERS,
    ...(options.headers || {}),
  };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(path, {
    ...options,
    headers,
    body: options.body != null ? JSON.stringify(options.body) : undefined,
  });

  let payload = null;
  const text = await res.text();
  try {
    payload = text ? JSON.parse(text) : null;
  } catch {
    payload = { success: false, error: { message: text || res.statusText } };
  }

  if (!res.ok || (payload && payload.success === false)) {
    const err = new Error(
      readableApiError(
        (payload && payload.error && payload.error.message) || text,
        res.status
      )
    );
    err.status = res.status;
    err.code = payload?.error?.code || null;
    err.payload = payload;
    throw err;
  }
  return payload.data !== undefined ? payload.data : payload;
}

export const api = {
  get: (path) => request(path),
  post: (path, body) => request(path, { method: 'POST', body }),
  put: (path, body) => request(path, { method: 'PUT', body }),
  del: (path) => request(path, { method: 'DELETE' }),
};

/**
 * Demo seed data for portal testing (kanban, messages, records).
 * ClientLayout merges these into the workspace alongside API matters.
 */
export const demoStore = {
  matters: demoSeedMatters,
  messages: demoSeedMessages,
};
